import { useEffect, useState } from "react";
import { adminApi, getAdminToken } from "../../lib/adminApi";

function formatDate(value) {
  return new Date(value).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function AdminVisitorsPage() {
  const [visits, setVisits] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    adminApi
      .listVisits(getAdminToken(), 200)
      .then(setVisits)
      .catch((err) => setError(err.message));
  }, []);

  if (error) return <p className="text-[#BE185D]">{error}</p>;

  return (
    <div>
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#EC4899]">Traffic</p>
      <h1 className="font-display text-4xl md:text-5xl mt-2">Visitors</h1>
      <p className="text-black/60 mt-3 max-w-2xl">
        Each public page view is logged with a visitor id (browser) and a session id (tab).
      </p>

      <div className="mt-8 overflow-x-auto rounded-3xl bg-white border border-black/5 shadow-ambient">
        <table className="w-full text-sm">
          <thead className="text-left font-mono text-[11px] uppercase tracking-widest text-black/45 border-b border-black/5">
            <tr>
              <th className="px-5 py-4">When</th>
              <th className="px-5 py-4">Page</th>
              <th className="px-5 py-4">Visitor</th>
              <th className="px-5 py-4">Referrer</th>
            </tr>
          </thead>
          <tbody>
            {visits.length === 0 && (
              <tr>
                <td colSpan={4} className="px-5 py-10 text-black/50">
                  No visitors recorded yet.
                </td>
              </tr>
            )}
            {visits.map((visit) => (
              <tr key={visit.id} className="border-t border-black/5">
                <td className="px-5 py-4 whitespace-nowrap">{formatDate(visit.visited_at)}</td>
                <td className="px-5 py-4 font-mono">{visit.path}</td>
                <td className="px-5 py-4 font-mono text-xs text-black/60">{(visit.visitor_id || "").slice(0, 8)}</td>
                <td className="px-5 py-4 text-black/60 max-w-xs truncate">{visit.referrer || "Direct"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
